/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockItemAddCtrl
 */
angular.module('mercury.modules.stock.item')
.controller('StockItemAddCtrl', ["dialog", "$filter", "$q", "$scope", "StockBrands", "StockItemGroups", "StockItems", "StockMasterItemGroups", "StockMasterItems", "StockSuppliers", "StockUnits", function(dialog, $filter, $q, $scope, StockBrands, StockItemGroups, StockItems,
    StockMasterItemGroups, StockMasterItems, StockSuppliers, StockUnits) {
  $scope.units = StockUnits.getAllActive();
  $scope.suppliers = StockSuppliers.getAll();
  $scope.brands = StockBrands.getAllActive();
  $scope.itemGroups = StockItemGroups.getAll();
  $scope.masterGroups = StockMasterItemGroups.getAll();
  $scope.items = StockItems.getAllActive();

  // note, $scope.masterItems is fetched per group, so and keyed on the
  // itemGroup Id field. Each item will be a resource from MasterItems, but the
  // object itsself is not
  $scope.masterItems = {};
  $scope.currentSuperGroupId = null;
  $scope.currentSubGroupId = null;
  $scope.filterMaster = '';
  var existingMasterItems = [];

  $scope.form = {};

  $scope.initialLoad = $q.all([
    $scope.masterGroups.$promise,
    $scope.units.$promise,
    $scope.suppliers.$promise,
    $scope.itemGroups.$promise,
    $scope.brands.$promise,
    $scope.items.$promise
  ]);

  var pullMasterItems = function() {
    var subGroupId = angular.copy($scope.currentSubGroupId);

    if (angular.isDefined($scope.masterItems[subGroupId]) === false) {
      $scope.loadingMasterItems = StockMasterItems.getAllByItemGroup(subGroupId);
      $scope.loadingMasterItems.then(function(result) {
        $scope.masterItems[subGroupId] = $scope.searchResults = $filter('filter')(result, function(masterItem) {
          return existingMasterItems.indexOf(masterItem.id) === -1;
        });
      });
    }
  };

  // default the currently selected supergroup id to the first returned supergroup
  // and default the subgroup id to the first subgroup in this supergroup
  $scope.initialLoad.then(function() {
    $scope.masterSuperGroups = {};

    angular.forEach($scope.masterGroups, function(group) {
      if (!$scope.masterSuperGroups[group.superGroupId]) {
        $scope.masterSuperGroups[group.superGroupId] = {
          id: group.superGroupId,
          name: group.superGroupName
        };

        if ($scope.currentSuperGroupId === null) {
          $scope.currentSuperGroupId = group.superGroupId;
          $scope.currentSubGroupId = group.id;
        }
      }
    });

    angular.forEach($scope.items, function(item) {
      if (item.masterId) {
        existingMasterItems.push(item.masterId);
      }
    });

    if ($scope.currentSuperGroupId) {
      pullMasterItems();
    }
  });

  $scope.changeSupergroup = function(id) {
    $scope.currentSuperGroupId = id;

    if (id != 'search') {
      $scope.currentSubGroupId = null;
      angular.forEach($scope.masterGroups, function(masterGroup) {
        if (!$scope.currentSubGroupId && masterGroup.superGroupId == $scope.currentSuperGroupId) {
          $scope.currentSubGroupId = masterGroup.id;
        }
      });

      pullMasterItems();
    }
  };

  $scope.changeGroup = function(subgroupId) {
    $scope.currentSubGroupId = subgroupId;
    pullMasterItems();
  };

  $scope.setSelected = function(selectedMasterItem) {
    $scope.selected = selectedMasterItem;
  };

  $scope.updateFilter = function(filterMaster) {
    $scope.searchResults = [];
    if (filterMaster !== '') {
      $scope.currentSuperGroupId = 'search';

      $scope.loadingMasterItems = StockMasterItems.getAllBySearchString(filterMaster);
      $scope.loadingMasterItems.then(function(result) {
        $scope.searchResults = $filter('filter')(result, function(masterItem) {
          return existingMasterItems.indexOf(masterItem.id) === -1;
        });
      });
    } else {
      $scope.changeSupergroup(Object.keys($scope.masterSuperGroups)[0]);
    }
  };

  $scope.customItem = {
    groupId: null,
    orderingUnitId: null,
    countingUnitId: null,
    defaultSupplierId: null,
    globalPrice: 0
  };
  $scope.addCustom = false;

  $scope.createMaster = function() {
    $scope.creatingItem = StockItems.newMaster($scope.selected.id);
    $scope.creatingItem.then(function(result) {
      $scope.$close(result);
    });
  };

  // change the Ordering Unit
  $scope.orderingUnitSet = function(newUnit) {
    var existingRatio = $scope.customItem.orderingUnitRatio || 1;
    // the base stock cost is the entered (and displayed) cost / the unit ratio, so recalculate so the displayed value
    // stays the same if they update the unit
    $scope.customItem.globalPrice = ($scope.customItem.globalPrice * existingRatio) / newUnit.ratio;
    $scope.customItem.orderingUnitRatio = newUnit.ratio;
  };

  $scope.createCustom = function() {
    $scope.form.customItemForm.$setSubmitted();
    if ($scope.form.customItemForm.$invalid) {
      return;
    }

    $scope.creatingItem = StockItems.newCustom($scope.customItem);
    $scope.creatingItem.then(function(response) {
      var result = {
        item: response
      };

      $scope.$close(result);
    }, function(response) {
      if (response.data && response.data.modelState) {
        $scope.modelState = response.data.modelState;
      }
    });
  };
}]);
